export enum OrderOriginEnum {
  appWeb = 1,
  appAndroid = 2,
  appIOS = 3,
  web = 4
}
